// extracted by mini-css-extract-plugin
module.exports = {"nav":"nav_nav__E77In"};